import { useCallback, useEffect, useState } from 'react'
import { useSelector } from "react-redux";
import _ from 'lodash';
import moment from 'moment';
import { Box } from '@mui/material';
import PricingSeasons from "./PricingSeasons";
import EmptyScreen from "./EmptyScreen";
import '../style.css';
import './pricing-model-3.css';
import { deepCopy } from "../../../app/util";
import { itIsPricingModel3Data } from './function';

const PricingModel3 = () => {
    const { app, auth } = useSelector((state) => state);
    const { property_details } = auth.profile || [];
    const { app_state } = app.current_state;
    const pricingSeasons = itIsPricingModel3Data(app_state.pricingSeasons);
    let prop_details_index = 0;
    const prop_details = property_details.find((item, index) => {
        if (item.id === app_state.property_id) {
            prop_details_index = index;
            return item.id === app_state.property_id;
        }
    });
    const { inventory_settings, pricing_settings } = prop_details?.system_settings && prop_details?.system_settings[0] ? prop_details?.system_settings[0] : null;
    const { room_dow_plans } = pricing_settings || { room_dow_plans: [] };
    const inventoryRoomCodes = inventory_settings.current.room_settings.map((item) => item.room_lodgiq_code);
    const inventoryRoomSettings = inventory_settings.current.room_settings;
    const [isConfigured, setIsConfigured] = useState(!(room_dow_plans?.length && room_dow_plans[0].room_plans));



    useEffect(() => {
        if ((pricingSeasons.initial.length === 0 && pricingSeasons.updated.length === 0)) {
            setIsConfigured(0);
        }
        else {
            if (room_dow_plans.length && room_dow_plans[0].status) {
                setIsConfigured(1);
            }
        }

    }, [pricingSeasons.initial.length, pricingSeasons.updated.length, app_state.property_id]);
    return (
        <Box className="pricing-model-3">
            {isConfigured ?
                <PricingSeasons isConfigured={isConfigured} setIsConfigured={setIsConfigured} inventoryRoomSettings={inventoryRoomSettings} />
                :
                <EmptyScreen handleConfigureClick={() => {
                    setIsConfigured(1)
                }} />
            }
        </Box>
    )
}

export default PricingModel3
